export const CREATE_SJFSERVER = "CREATE_SJFSERVER";
export const RETRIEVE_SJFSERVER = "RETRIEVE_SJFSERVER";
export const RETRIEVESINGLE_SJFSERVER = "RETRIEVESINGLE_SJFSERVER";
export const UPDATE_SJFSERVER = "UPDATE_SJFSERVER";
export const DELETE_SJFSERVER = "DELETE_SJFSERVER";